module.exports = __webpack_public_path__ + "img/information-outline.b6e39364.svg";